import { type ApiCoreContextValue } from "contexts";

export const makePublishedLeafNodeResolvers = (
  client: ApiCoreContextValue["client"],
  sessionManager: ApiCoreContextValue["sessionManager"],
  store: ApiCoreContextValue["store"]
) => ({});
